import moment, { Moment } from 'moment-timezone';
import { Property } from 'shared-types/Property';
import { MultiRoomSearch, PromoRateCode } from 'shared-types/Common';
import { NormalizedStore } from '@store/entity/entity.types';
import { SPA_DEFAULT_ADULTS } from '@common/constants';
import { getEntityItemSelector } from '../entity/selectors';

export type ParsedJourneyParams = {
  fromDate: Moment;
  toDate?: Moment;
  spaDate?: Moment;
  adults: number;
  children: number;
  spaAdults: number;
  promoRateCode?: PromoRateCode;
  tableAdults?: number;
  tableChildren?: number;
  childAges: { [child: string]: number };
  rooms: MultiRoomSearch;
};

export const yourJourneySelectors = {
  getParsedJourneyParams: (state: NormalizedStore): ParsedJourneyParams => {
    const property: Property = getEntityItemSelector('properties')(state);

    const {
      fromDate,
      toDate,
      adults,
      children,
      spaAdults,
      spaDate,
      promoRateCode,
      tableAdults,
      tableChildren,
      childAges,
      rooms,
    } = state.yourJourney;

    const formatDate = (date: string) => moment.tz(date, property?.timezone);

    const safeJSONParse = (jsonString: string) => {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        return {};
      }
    };

    return {
      fromDate: formatDate(fromDate),
      toDate: toDate ? formatDate(toDate) : undefined,
      spaDate: formatDate(spaDate || fromDate),
      adults: adults ?? 0,
      children: children ?? 0,
      spaAdults: spaAdults ?? SPA_DEFAULT_ADULTS,
      promoRateCode,
      tableAdults: tableAdults,
      tableChildren: tableChildren,
      childAges: safeJSONParse(childAges),
      rooms: safeJSONParse(rooms),
    };
  },
  getActualSpaDateValue: (state: NormalizedStore) => state.yourJourney?.spaDate,
};
